
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tourism-and-aviation-connectivity-forum",
      function () {
        return require("private-next-pages/tourism-and-aviation-connectivity-forum.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tourism-and-aviation-connectivity-forum"])
      });
    }
  